"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.FeefoScoreBadge = void 0;
var _feefoScoreBadge = _interopRequireDefault(require("./components/feefo-score-badge"));
exports.FeefoScoreBadge = _feefoScoreBadge["default"];